'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.SeverityType = void 0;
(function (SeverityType) {
    SeverityType["SUCCESS"] = "success";
    SeverityType["ERROR"] = "error";
    SeverityType["WARNING"] = "warning";
})(exports.SeverityType || (exports.SeverityType = {}));
exports.DisplayTimeType = void 0;
(function (DisplayTimeType) {
    DisplayTimeType["DEFAULT"] = "default";
    DisplayTimeType["CUSTOM"] = "custom";
})(exports.DisplayTimeType || (exports.DisplayTimeType = {}));
//# sourceMappingURL=ToastTypes.js.map
